import { formatNumber } from '@core/utils/string';
import { FCX } from '@models';
import { components } from '@core/api/api';

const CONFIG: Array<{
    title: string;
    key: keyof components['schemas']['ItemsCount'];
}> = [
    { title: 'express items:', key: 'express' },
    { title: 'full concepts:', key: 'fullConcept' },
    { title: 'public items:', key: 'public' },
    { title: 'other items:', key: 'other' },
    { title: 'TOTAL ITEMS IN THIS SURVEY:', key: 'total' },
]

const ItemsCount: FCX<{
    data?: components['schemas']['ItemsCount'];
}> = ({
    data,
}) => {
    if (!data) {
        return null;
    }

    return (
        <>
            <div className="SurveyDetails__spacer"/>
            <div className="SurveyDetails__param-column">
                <div className="SurveyDetails__section-title">Item count</div>
                {CONFIG.map((config) => (
                    <div className="SurveyDetails__param-row" key={config.key}>
                        <div className="SurveyDetails__param-title">
                            {config.title}
                        </div>
                        <div className="SurveyDetails__param-value right-align">
                            {formatNumber(data[config.key] ?? 0)}
                        </div>
                    </div>
                ))}
            </div>
        </>
    );
};

export default ItemsCount;